<template>
	<EMCoreTemplate category="OSMLife" identity="insuredBenefits" entity="osm_insured_benefits"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementLife/containers/InsuredBenefits.vue